import UltMeta, { Meta } from "./UltMeta/index";

// 业务类型
class BusinessType extends UltMeta {
    CONSIGNMENT = new Meta(1, "寄售");
    GROUP_BUYING_PRODUCTS = new Meta(2, "团购");
    PICKING_UP_MISSING_PRODUCTS = new Meta(3, "捡漏");
    SUPPLIER = new Meta(4, "供应商");
}

export const FAVORITE_FOLLOW_BUSINESS_TYPE = new BusinessType();


// 操作类型
class OperationType extends UltMeta {
    /**收藏 */
    FAVORITE = new Meta(1, "收藏");
    /**关注 */
    FOLLOW = new Meta(2, "关注");
}
export const FAVORITE_FOLLOW_OPERATION_TYPE = new OperationType();
